'use client'
import { PrismicRichText, PrismicImage, PrismicLink } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import '@splidejs/react-splide/css/core';
import Marquee from "react-fast-marquee";

/**
 * @typedef {import("@prismicio/client").Content.LogoSlice} LogoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LogoSlice>} LogoProps
 * @type {import("react").FC<LogoProps>}
 */
const Logo = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`pl-4 md:pl-10 mt-10 flex overflow-hidden items-center`}
    >
      {isFilled.keyText(slice.primary.title) && (
        <div className="shrink-0 relative">
          <h2 className="text-logo-title w-full max-w-40 md:max-w-45 lg:max-w-none pr-4 md:pr-10 ">{slice.primary.title} </h2>
        </div>
      )}

      {isFilled.group(slice.primary.logos) && (
        <div className="flex-1">
          <Marquee
                gradient={false}
                speed={50}
                pauseOnHover={false}
                aria-hidden="true"
              >
            {slice.primary.logos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center">
                {isFilled.image(logo.img) && (
                  <PrismicImage
                    field={{
                      ...logo.img,
                      alt: logo.img.alt || "Logo d'illustration"
                    }}
                    className="h-20 w-auto object-contain"
                  />
                )}
              </div>
            ))}
          </Marquee>
        </div>
      )}
    </section>
  );
};

export default Logo;
